import React, { useContext } from 'react'
import { TextContext } from 'hocs'
import * as Styled from './PdfReport.styles'

const PdfReport = ({ link }) => {
  const textContext = useContext(TextContext)
  return (
    <Styled.Wrapper container justifyContent='flex-end'>
      <a
        // className="btn"
        href={ link }
        target='_blank'
        rel='noopener noreferrer'
        title={ textContext['pdfReport.linkText'] }>
        {textContext['pdfReport.linkText']}
      </a>
    </Styled.Wrapper>
  )
}

export default PdfReport
